import React from 'react';
import { motion } from 'framer-motion';
import { GlassCard } from '../ui/GlassCard';
import { Target, Megaphone } from 'lucide-react';
export function Slide18TwoPaths() {
  const qualify = ['Segment around the problem', 'Identify ICPs', 'Focus on customers who feel the pain', 'Narrow positioning', 'Precision targeting'];
  const change = ['Educate the market', 'Explain scientific differentiation', 'Reframe buying criteria', 'Build credibility signals', 'Shift perception'];
  return <div className="w-full h-full flex flex-col max-w-7xl mx-auto pt-10" data-id="element-533">
      <motion.h2 className="text-[clamp(2.2rem,3.6vw,3.6rem)] font-light tracking-tight mb-12 text-center text-snakker-ink" initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-534">
        Once the gap is identified,{' '}
        <span className="text-snakker-subtle" data-id="element-535">two strategic paths emerge.</span>
      </motion.h2>

      <div className="flex gap-8 flex-1 mb-8" data-id="element-536">
        {/* LEFT - Qualify the Market */}
        <motion.div className="w-1/2" initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2
      }} data-id="element-537">
          <GlassCard className="h-full flex flex-col border-snakker-primary/30 relative overflow-hidden" data-id="element-538">
            <div className="absolute top-0 right-0 w-40 h-40 bg-snakker-primary/10 blur-[80px] rounded-full" data-id="element-539" />

            <div className="flex items-center gap-3 mb-6 relative z-10" data-id="element-540">
              <div className="w-10 h-10 rounded-xl bg-snakker-primary/15 flex items-center justify-center" data-id="element-541">
                <Target className="w-5 h-5 text-snakker-primary" data-id="element-542" />
              </div>
              <div data-id="element-543">
                <div className="text-xs font-mono uppercase tracking-widest text-snakker-primary" data-id="element-544">
                  Path A
                </div>
                <h3 className="text-2xl font-medium text-snakker-ink" data-id="element-545">
                  Qualify the Market
                </h3>
              </div>
            </div>

            <ul className="space-y-3 mb-8 relative z-10" data-id="element-546">
              {qualify.map((item, i) => <motion.li key={i} className="flex items-center gap-3 text-snakker-ink" initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.5 + i * 0.1
            }} data-id="element-547">
                  <div className="w-1.5 h-1.5 rounded-full bg-snakker-primary" data-id="element-548" />
                  {item}
                </motion.li>)}
            </ul>

            <div className="mt-auto p-4 rounded-xl bg-snakker-primary/[0.06] border border-snakker-primary/20 relative z-10" data-id="element-549">
              <div className="text-[10px] font-mono uppercase tracking-widest text-snakker-primary mb-1" data-id="element-550">
                Outcome
              </div>
              <div className="text-snakker-ink font-medium" data-id="element-551">
                Higher conversion efficiency
              </div>
            </div>
          </GlassCard>
        </motion.div>

        {/* RIGHT - Change Perception */}
        <motion.div className="w-1/2" initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4
      }} data-id="element-552">
          <GlassCard className="h-full flex flex-col border-snakker-secondary/30 relative overflow-hidden" data-id="element-553">
            <div className="absolute top-0 right-0 w-40 h-40 bg-snakker-secondary/10 blur-[80px] rounded-full" data-id="element-554" />

            <div className="flex items-center gap-3 mb-6 relative z-10" data-id="element-555">
              <div className="w-10 h-10 rounded-xl bg-snakker-secondary/15 flex items-center justify-center" data-id="element-556">
                <Megaphone className="w-5 h-5 text-snakker-secondary" data-id="element-557" />
              </div>
              <div data-id="element-558">
                <div className="text-xs font-mono uppercase tracking-widest text-snakker-secondary" data-id="element-559">
                  Path B
                </div>
                <h3 className="text-2xl font-medium text-snakker-ink" data-id="element-560">
                  Change Market Perception
                </h3>
              </div>
            </div>

            <ul className="space-y-3 mb-8 relative z-10" data-id="element-561">
              {change.map((item, i) => <motion.li key={i} className="flex items-center gap-3 text-snakker-ink" initial={{
              opacity: 0,
              x: -10
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.7 + i * 0.1
            }} data-id="element-562">
                  <div className="w-1.5 h-1.5 rounded-full bg-snakker-secondary" data-id="element-563" />
                  {item}
                </motion.li>)}
            </ul>

            <div className="mt-auto p-4 rounded-xl bg-snakker-secondary/[0.06] border border-snakker-secondary/20 relative z-10" data-id="element-564">
              <div className="text-[10px] font-mono uppercase tracking-widest text-snakker-secondary mb-1" data-id="element-565">
                Outcome
              </div>
              <div className="text-snakker-ink font-medium" data-id="element-566">
                Higher strategic market value
              </div>
            </div>
          </GlassCard>
        </motion.div>
      </div>

      <motion.div className="text-center" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5
    }} data-id="element-567">
        <p className="text-lg font-light tracking-wide text-snakker-muted" data-id="element-568">
          The right strategy depends on whether the challenge is{' '}
          <span className="text-snakker-ink font-medium" data-id="element-569">
            capability or perception.
          </span>
        </p>
      </motion.div>
    </div>;
}